module.exports = __webpack_public_path__ + "static/media/PB_G_11.627e9b23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/progress_bar/green/PB_G_11.png
// module id = 224
// module chunks = 0